<template lang="html">
	<section class="take-place column">
		<div class="take-place from-start column">
			<div class="heading-sub-client-container">
				<div class="heading-sub-client row start">
					<router-link :to="{name: 'Client', params: { clientId: client.id}}" class="btn-icon">
						<span class="icon-arrow-back"></span>
					</router-link>
					<div class="level take-place">
						<div class="level-left">
							<div class="label">Agrégation manuel de <span>{{ client.firstname }} {{ client.lastname }}</span>
							</div>
						</div>
						<div class="level-right">
							<router-link :to="{ name: 'InvestmentsManualAdd' }" class="btn btn-red ctn-icon">
								<span class="icon-button-new-mission"></span>
								Nouveau produit
							</router-link>
						</div>
					</div>
				</div>
			</div>

			<div class="master-investments master-investments-manual">
				<div class="group">
					<div class="title">
						Produits
					</div>
					<div class="ctn-several row">
						<div class="white-box with-tags with-array take-place">
							<div class="ctn-table ctn-section-table row">
								<section-table
									:columns="cols"
									:rows="rows"
									@action-item-clicked="onActionItemClicked"/>
							</div>
						</div>
					</div>
				</div>
			</div>

		</div>
	</section>
</template>

<script>

import SectionTable from '@/common/components/section-table'
import {mapGetters} from 'vuex'

export default {
	name: 'InvestmentsManual',
	components: {SectionTable},
	props: {
		kind: {type: String, default: 'cgpi'}
	},
	data () {
		return {
			client: null,
			hover: false,
			cols: [
				{name: 'Produit', field: 'name', width: 340},
				{name: 'Type de produit', field: 'product_type', width: 230},
				{name: 'Numéro de contrat', field: 'contract_number', width: 250},
				{name: 'Type de contrat', field: 'contract_type', width: 230},
				(this.isCgpi) ? {name: 'Source', field: 'source', width: 230} : {},
				{name: 'Mise à jour', field: 'updated_at', width: 230},
				{
					name: 'Actions',
					field: 'actions',
					width: 130,
					actions: [
						{
							name: 'edit',
							icon: 'icon-file-edit'
						},
						{
							name: 'delete',
							icon: 'icon-file-trash'
						}
					]
				}
			],
			options: {},
			rows: []
		}
	},
	created () {
		this.client = this.$store.getters.getClient(this.$route.params.clientId)
	},
	mounted () {
		this.initializeClientProducts()
	},
	methods: {
		initializeClientProducts () {
			let clientId

			clientId = this.$route.params.clientId

			this.$store.dispatch('getClientInvestmentProducts', clientId).then(() => {
				this.rows = []

				for (let index in this.investmentProducts) {
					const product = this.investmentProducts[index]
					this.initializeProductInRows(product)
				}
			})
		},
		initializeProductInRows (product) {
			this.rows.push({
				data: {
					id: product.id,
					name: product.product_name,
					product_type: product.product_type,
					contract_type: product.contract_type,
					net_income_distributed: this.getCurrencyWithSymbol(product.net_income_distributed, '€'),
					contract_number: product.contract_number,
					updated_at: product.updated_at,
					source: product.source_label
				}
			})
		},
		getCurrencyWithSymbol (value, currencyType) {
			return value ? value.toLocaleString() + ' ' + currencyType : ''
		},
		onActionItemClicked ({row, action}) {
			if (action.name === 'edit') {
				this.$router.push({ name: 'InvestmentsManualForm', params: { clientId: this.isCgpi ? this.$route.params.clientId : null, id: row.data.id, kind: this.kind } })
			} else if (action.name === 'delete') {
				this.deleteProductWithConfirmation(row.data)
			}
		},
		deleteProductWithConfirmation (product) {
			this.$swal.fire({
				title: 'Etes-vous sûr ?',
				text: `Le produit "${product.name}" sera supprimé.`,
				icon: 'warning',
				confirmButtonColor: '#ff4052',
				showCancelButton: true,
				confirmButtonText: 'confirmer',
				cancelButtonText: 'Annuler'
			}).then((result) => {
				if (result.value) {
					this.deleteProduct(product)
					this.initializeClientProducts()
				}
			})
		},
		deleteProduct (product) {
			this.$store.dispatch('deleteInvestmentProducts', product.id).then(() => {
				this.$notify({
					type: 'success',
					group: 'default',
					title: 'Produit supprimé',
					text: 'Le produit a bien été supprimé !'
				})
			})
		}
	},
	computed: {
		...mapGetters({
			investmentProducts: 'investmentProducts'
		}),
		isCgpi () {
			return this.kind === 'cgpi'
		}
	}
}
</script>



// WEBPACK FOOTER //
// InvestmentsManual.vue?3856d2d3